// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import CountrySelectorView from '../views/CountrySelector';
import HeaderCountrySelectorNewDesign from '../views/HeaderCountrySelectorNewDesign';
import HeaderCountrySelector from '../views/HeaderCountrySelector.view';

const CountrySelectorWrapper = (props) => {
  const { isHeaderRedesignCountrySelector, isGlobalDefaultHeaderRedesignEnabled } = props;

  if (isGlobalDefaultHeaderRedesignEnabled) {
    return <HeaderCountrySelectorNewDesign {...props} />;
  }

  if (!isHeaderRedesignCountrySelector) {
    return <CountrySelectorView {...props} />;
  }
  return <HeaderCountrySelector {...props} />;
};

CountrySelectorWrapper.propTypes = {
  isHeaderRedesignCountrySelector: PropTypes.bool,
  isGlobalDefaultHeaderRedesignEnabled: PropTypes.bool,
};

CountrySelectorWrapper.defaultProps = {
  isHeaderRedesignCountrySelector: false,
  isGlobalDefaultHeaderRedesignEnabled: false,
};

export default CountrySelectorWrapper;
